import {FC} from 'react';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import App from '../App';
import {useConfig} from '../common/providers/ConfigProvider';
import {AuthRoutes, useAuth} from '../modules/auth';
import {ErrorRoutes} from '../modules/errors';
import PrivateRoutes from './PrivateRoutes';
import {routes} from './routes';
import Term from '../common/components/layout/footer/Term';
import Privacy from '../common/components/layout/footer/Privacy';

const AppRoutes: FC = () => {
	const {currentUser} = useAuth();
	const {publicUrl} = useConfig();

	return (
		<BrowserRouter basename={publicUrl}>
			<Routes>
				<Route element={<App />}>
					<Route path='error/*' element={<ErrorRoutes />} />
					{currentUser ? (
						<>
							<Route path='/*' element={<PrivateRoutes />} />
							<Route index element={<Navigate to={routes.dashboard} />} />
						</>
					) : (
						<>
							<Route path={routes.authAny} element={<AuthRoutes />} />
							<Route path='*' element={<Navigate to={routes.authBase} />} />
						</>
					)}
				</Route>
				<Route path={routes.term} element={<Term />} />
				<Route path={routes.privacy} element={<Privacy />} />
			</Routes>
		</BrowserRouter>
	);
};

export default AppRoutes;
